import { fromJS, List } from 'immutable';
import { TABLE } from '../../../constants/chartTypes';
import { UNIFIED_EVENTS } from '../../../constants/dataTypes';
import { DRILLDOWN_TYPES } from '../../../constants/trackingMetrics';
import { getUnifiedEventSchema } from '../../../lib/unifiedEvents/fetchSchema';
import { detemineNodeBasedOnReport, getUEReportType, getUESchemaVersion } from '../../../lib/unifiedEvents/utils';
import { isUETimeSeriesReport } from '../../../report/reportGetters';
import { fixCompareFilters, getUpdatedDateRange } from '../filters';
const UNIFIED_EVENTS_SPECIAL_DATE_DIMENSION = 'date';
const isSupportedUETimeSeriesReport = report => {
  return isUETimeSeriesReport(report) && report.getIn(['config', 'dimensions', 0]) === UNIFIED_EVENTS_SPECIAL_DATE_DIMENSION;
};
const updateUETimeSeriesReportDimensions = report => {
  return report.setIn(['config', 'dimensions'], report.getIn(['config', 'dimensions']).shift());
};
const updateUETimeSeriesDateFilter = (reportConfig, bucket, options = {}) => {
  const shouldUseCompare = options.isComparisonPriorPeriod || options.datasetKey === 'compare';
  if (shouldUseCompare) {
    reportConfig = reportConfig.update('filters', fixCompareFilters(reportConfig, List([bucket]), Object.assign({
      shouldUseCompare
    }, options)));
  }
  return getUpdatedDateRange(bucket, reportConfig, options);
};
const drilldownChildrenAvailable = report => getUnifiedEventSchema(getUEReportType(report), getUESchemaVersion(report)).then(schema => {
  const node = detemineNodeBasedOnReport(schema, report);
  return Object.keys(node.children).length > 0;
});
const generateUnifiedEventsDrilldown = (report, [bucket, column], options) => {
  return getUnifiedEventSchema(getUEReportType(report), getUESchemaVersion(report)).then(schema => {
    const {
      name
    } = options;
    const isUETimeSeriesDrilldown = isSupportedUETimeSeriesReport(report);
    if (isUETimeSeriesDrilldown) {
      report = updateUETimeSeriesReportDimensions(report);
    }
    const reportDimensions = report.getIn(['config', 'dimensions'], List());
    const node = detemineNodeBasedOnReport(schema, report);
    const drillOptions = node && Object.keys(node.children);

    /*
     Choosing the first property to drill into may not be the long term
     solution. Depending on how we answer some remaining UX questions, the user
     may be given an oppurtunity to choose which property to drill along.
    */

    const drillProperty = isUETimeSeriesDrilldown && reportDimensions.size === 0 ? UNIFIED_EVENTS_SPECIAL_DATE_DIMENSION : drillOptions && drillOptions[0];
    const currentDimension = reportDimensions.get(0);
    return report.set('chartType', TABLE).updateIn(['config', 'filters', 'custom'], filters => currentDimension && drillProperty !== UNIFIED_EVENTS_SPECIAL_DATE_DIMENSION ? filters.filter(filter => filter.get('property') !== currentDimension).push(fromJS({
      property: currentDimension,
      operator: 'EQ',
      value: isUETimeSeriesDrilldown ? column : bucket
    })) : filters).updateIn(['config', 'filters', 'dateRange', 'value'], dateRangeFilterValue => isUETimeSeriesDrilldown ? updateUETimeSeriesDateFilter(report.get('config').delete('unifiedEvent'), bucket, options) : dateRangeFilterValue).setIn(['config', 'dimensions', 0], drillProperty).set('name', name);
  });
};
export default {
  isSupported: report => {
    if (report.getIn(['config', 'dataType']) !== UNIFIED_EVENTS || report.getIn(['config', 'dimensions', 0]) === UNIFIED_EVENTS_SPECIAL_DATE_DIMENSION && !isSupportedUETimeSeriesReport(report)) {
      return Promise.resolve(false);
    }
    const reportToFindDrilldownChildren = isSupportedUETimeSeriesReport(report) ? updateUETimeSeriesReportDimensions(report) : report;
    return drilldownChildrenAvailable(reportToFindDrilldownChildren);
  },
  generate: generateUnifiedEventsDrilldown,
  trackingName: DRILLDOWN_TYPES.UNIFIED_EVENTS
};
export const __TESTABLE__ = {
  generateUnifiedEventsDrilldown,
  drilldownChildrenAvailable
};